import Button, { ButtonProps } from '@portalterreno/react-ui-core/Button';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../../redux/store';

export type CancelButtonProps = Omit<
  ButtonProps,
  'fullWidth' | 'color' | 'variant'
>;

const CancelButton: FC<CancelButtonProps> = (props) => {
  const { t } = useTranslation();
  const isLoading = useSelector(
    (state: RootState) => state.multipleLeads.isLoading,
    shallowEqual
  );

  return (
    <Button
      {...props}
      fullWidth
      color='secondary'
      variant='outlined'
      disabled={isLoading}
    >
      {t('property:multipleLeadModalCancelButton')}
    </Button>
  );
};

export default CancelButton;
